import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('workflow', 'execucao/acao');

const workflowAcaoActions = {
  solicitante: { method: 'GET', url: `${basePath}/solicitante/{idAcao}` },
  buscaPassosClientes: { method: 'GET', url: `${basePath}/{idAcao}/passos/cliente` },
  associaUsuarioClienteAprovador: { method: 'POST', url: `${basePath}/{idAcao}/passos/{idPasso}/cliente/usuario/{idUsuario}` },
  iniciaFluxo: { method: 'POST', url: `${basePath}/{idAcao}` },
  aprovador: { method: 'GET', url: `${basePath}/{idAcao}/passos/aprovador` },
  aprovarPasso: { method: 'PUT', url: `${basePath}/{idAcao}/passos/aprovar` },
  reprovar: { method: 'PUT', url: `${basePath}/{idAcao}/passos/reprovar` },
  enviarAnalise: { method: 'PUT', url: `${basePath}/{idAcao}/passos/analise` },
  status: { method: 'GET', url: `${basePath}/{idAcao}/status` },
  statusPasso: { method: 'GET', url: `${basePath}/{idAcao}/passos/status` },
};
export default resource => resource(`${basePath}`, {}, workflowAcaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/workflow-acao.js